import UiBox from '../../components/shared/Box';
import UiHeading from '../../components/shared/Heading';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

const TrialTitle = (): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const route: any = sitecoreContext?.route;
  const trialTitle = route?.fields?.trialTitle;

  return (
    <UiBox styles={{ flex: 1 }}>
      <UiHeading size="h2" data-testid="trial-title">
        {trialTitle}
      </UiHeading>
    </UiBox>
  );
};

export default TrialTitle;
